import Swal, {SweetAlertIcon} from "sweetalert2";

interface IToastOptions {
    sticky?: boolean;
    timerMs?: number;
    showCloseButton?: boolean;
}

const toast = (icon:SweetAlertIcon, title:string, options: IToastOptions = {}) => {
    const sticky = options.sticky === true;
    const timerMs = options.timerMs ?? 5000;
    const showCloseButton = options.showCloseButton ?? !sticky;

    return Swal.fire({
        toast:true,
        icon:icon,
        title:title,
        position: 'top-end',
        showConfirmButton: false,
        timer: sticky ? undefined : timerMs,
        showCloseButton: showCloseButton,
        timerProgressBar: !sticky,
        didOpen: (toastElement) => {
            if (sticky) return;
            toastElement.addEventListener('mouseenter', Swal.stopTimer)
            toastElement.addEventListener('mouseleave', Swal.resumeTimer)
        }
    })
}

const closeToast = () => {
    const popup = Swal.getPopup();
    if (popup?.classList.contains('swal2-toast')) {
        Swal.close();
    }
}

export {toast, closeToast}
